module.exports = __webpack_public_path__ + "static/img/s-4.e423458.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/Pages/ComicDetail/img/comics/s-4.jpg
// module id = 494
// module chunks = 0